import { render } from "./ModalUploadDocumentsMonthly.vue?vue&type=template&id=87064b4c&scoped=true"
import script from "./ModalUploadDocumentsMonthly.vue?vue&type=script&lang=js"
export * from "./ModalUploadDocumentsMonthly.vue?vue&type=script&lang=js"

import "./ModalUploadDocumentsMonthly.vue?vue&type=style&index=0&id=87064b4c&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87064b4c"]])

export default __exports__